import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-requisition-create',
  templateUrl: './requisition-create.component.html',
  styleUrls: ['./requisition-create.component.css']
})
export class RequisitionCreateComponent implements OnInit {
    stockKeynoFrom;

    stockKeynoTo;

    public edit?: Edit;

    public creating = false;

    public stockPlaceNameFromButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockget', gotoParms: () => this.edit!.stock_keyno_from ?? '' }];

    public stockPlaceNameToButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockget', gotoParms: () => this.edit!.stock_keyno_to ?? '' }];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeynoFrom = this.stateService.getStateParams()['stock_keyno_from'];
        this.stockKeynoTo = this.stateService.getStateParams()['stock_keyno_to'];
    }

    private async loadEdit() {
        if (!!this.stockKeynoFrom && !!this.stockKeynoTo) {
            this.edit = (await this.datatask.Post(760, {
                stock_keyno_from: this.stockKeynoFrom,
                stock_keyno_to: this.stockKeynoTo
            }))[0];
        }
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;
                
                await this.datatask.Post(761, this.edit);

                this.stateService.go('stockget', { stock_keyno: this.edit.stock_keyno_to });
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stock_keyno_from: string;
    stock_keyno_to: string;
    infotext: string;
    quantity: string;
    stockplace_name_from: string;
    stockplace_name_to: string;
    prod_id: string;
    prodname_long: string;
    quantity_available: string;
    note: string;
    url_picture: string;
}
